import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import './home-styles.css';
import NoMatch from '../no-match/NoMatch';
import HomeMainContent from './HomeMainContent';



function Home({ routes }) {
	const { lang } = useParams();
    const defaultLang = 'es';  

    return ( 
        <Routes>
            <Route path="/" element={<HomeMainContent   lang={lang || defaultLang} routes={routes}   />} /> 
            <Route path="*" element={<NoMatch />} />
        </Routes>
    ); 
}

export default Home;